export default __webpack_public_path__ + "static/media/bowling.52c96d8d.jpg";